import React from "react";
import {MessageBar} from "@fluentui/react";

import styles from "./IsaacMessageBar.module.scss";
import type IsaacMessageBarProps from "./IsaacMessageBarProps";

const IsaacMessageBar: React.FC<IsaacMessageBarProps> = ({
  messageBarType,
  children,
  className,
}) => {
  return (
    <div className={styles.container}>
      <MessageBar
        messageBarType={messageBarType}
        className={className}
        styles={{root: {whiteSpace: "pre-wrap"}}}>
        {children}
      </MessageBar>
    </div>
  );
};

export default IsaacMessageBar;
